<template>
    <!--        樓層選擇框         -->
    <div class="select-area-box">
        <div class="select-area-div" :style="{background: `url(${publicPath}static/images/ev123.jpg)`}">
            <div class="close-material-box-btn" @click="clickClose">
                <font-awesome-icon icon="fa-solid fa-xmark" />
            </div>

            <ul class="select-ul">
                <li style="margin-bottom: 20px">
                    <el-button type="info" size="large" round @click="clickReturn" style="box-shadow: 0px 0px 15px 2px black;">{{i18n.tkey("lang_return_3d_city")}}</el-button>
                </li>
                <li style="margin-bottom: 20px" v-show="floorType === 1||floorType === 2">
                  <el-button type="info" size="large" round @click="clickgoMall" style="box-shadow: 0px 0px 15px 2px black;">{{i18n.tkey("lang_market")}}</el-button>
                </li>
              <li style="margin-bottom: 20px" v-show="floorType === 1">
                <el-button type="info" size="large" round @click="clickClose" style="box-shadow: 0px 0px 15px 2px black;">{{i18n.tkey("lang_hall_1")}}</el-button>
              </li>
                <li class="title-part" style="color: #fefefe" v-show="floorType !== 1">

                    <!--                        <span style="float: right" @click="closeSelectFloor">×</span>-->
                    {{i18n.tkey("lang_select_floor_num_pls")}}
                </li>

                <li class="content-part" v-show="floorType !== 1">
                    <el-scrollbar>
                        <ul class="select-input-part">
                            <li>
                                <div class="select-floor-btn-group-box">

                                    <div v-for="n in (Math.ceil(lastPageNum / 100))" :key="n + 'a'" style="width: 110px">
                                        <div v-for="m in lastPageNum" :key="m" :label="m" :value="m">
                                            <elevatorFloorBtn class="select-floor-btn" @click="clickFloor(m)" :selectTag="m == currPage" v-if="m > (n - 1) * 10 && m <= n * 10">
                                                <span>{{m}}</span>
                                            </elevatorFloorBtn>
                                        </div>
                                    </div>

                                </div>

                            </li>
                        </ul>
                    </el-scrollbar>

                </li>

            </ul>
        </div>
    </div>
</template>

<script setup>

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import ElevatorFloorBtn from "@/components/elevatorFloorBtn.vue";
import {inject, ref} from "vue";

const props = defineProps(["lastPageNum", "currPage","floorType"])
const emits = defineEmits(["clickClose", "clickReturn", "clickgoMall", "clickFloor"])

const publicPath = process.env.BASE_URL

const i18n = inject("i18n")

function clickClose(){
    emits("clickClose")
}

function clickReturn(){
    emits("clickReturn")
}

function clickgoMall(){
  emits("clickgoMall")
}

function clickFloor(num){
    emits("clickFloor", num)
}

</script>

<style scoped>
ul{
    list-style: none;
    padding-left: 0;
    margin: 0;
}

.select-area-box {
    position: absolute;
    z-index: 400;
    width: 100%;
    height: 100%;
    background: #00000091;
    display: flex;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 520px) {
    .select-area-box .select-area-div {
        /*width: 50%;*/
        width: 280px;
        height: 60%;
        padding: 20px;
        border-radius: 15px;
        background: #fefefe;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        user-select: none;

        box-sizing: border-box;
        position: relative;
    }
}

@media screen and (max-width: 520px) {
    .select-area-box .select-area-div {
        /*width: 85%;*/
        width: 280px;
        height: 60%;
        padding: 20px;
        border-radius: 15px;
        background: #fefefe;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        user-select: none;

        box-sizing: border-box;
        position: relative;
    }
}

.select-area-box .select-area-div .select-ul {
    width: 100%;
    height: 100%
}

.select-area-box .select-area-div .select-ul .title-part {
    height: 30px;
}

.select-area-box .select-area-div .select-ul .content-part {
    height: calc(100% - 105px);
    /*display: flex;*/
    /*align-items: center;*/

    overflow-y: auto;

}

.select-area-box .select-area-div .select-ul .btns-part {
    height: 30%;
    display: flex;
    align-items: flex-end;
}

.select-area-box .select-input-part {
    display: flex;
    justify-content: center;
    /*margin-top: 20%;*/
    width: 100%;
}

.select-area-box .operation-box{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 30px;
    /*margin-top: 20%;*/
    user-select: none;

    width: 100%;
}

.select-area-box .operation-box .btn-box{
    padding: 5px 25px;
    border-radius: 5px;
}

.select-area-box .operation-box .sure-box{
    border: 1px #d6e9c6 solid;
    background: #d6e9c6;
    color: #3c763d;
}

.select-area-box .operation-box .sure-box:hover{
    border: 1px #3c763d solid;
    background: #3c763d;
    color: #d6e9c6;
}

.select-area-box .operation-box .refuse-box{
    border: 1px #ebccd1 solid;
    background: #ebccd1;
    color: #a94442;
}

.select-area-box .operation-box .refuse-box:hover{
    border: 1px #a94442 solid;
    background: #a94442;
    color: #ebccd1;
}

.close-material-box-btn {
    display: inline-block;
    position: absolute;
    top: -20px;
    right: -20px;
    font-size: 20px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
    background: -webkit-linear-gradient(top, #e92323, #551d1d);
    color: #ffffff;
    line-height: 30px;
}

.select-floor-btn-group-box {
    display: flex;
    justify-content: center;
    width: 100%;
}

.select-floor-btn-group-box .select-floor-btn-group {
    width: 110px;
}

.select-floor-btn-group-box .select-floor-btn-group .select-floor-btn {
    margin-bottom: 15px;
    margin-top: 15px;
}

.select-floor-btn {
    margin-bottom: 20px;
    margin-top: 20px;
}

</style>